import { ManagementStyleDTO } from '../api/useIncomeQuery';
import { EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE } from '../forms/components/AssetBucket/AssetBucket';

interface Params {
  isAssetBucketingByManagementStyle: boolean;
  orionManagementStyleId: number | null;
  managementStylesOptions: ManagementStyleDTO[];
  customBucketIndex: number | null;
}

export const getDefaultCustomBucketIndex = ({
  isAssetBucketingByManagementStyle,
  orionManagementStyleId,
  managementStylesOptions,
  customBucketIndex,
}: Params) => {
  if (isAssetBucketingByManagementStyle) {
    if (orionManagementStyleId === null) {
      return null;
    }

    if (customBucketIndex === null) {
      const selectedManagementStyle = (managementStylesOptions || []).find(
        option => option.id === orionManagementStyleId,
      );

      if (!selectedManagementStyle) {
        return null;
      }

      return selectedManagementStyle.defaultBucket === null
        ? EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE
        : selectedManagementStyle.defaultBucket;
    }
  }

  return customBucketIndex;
};
